









































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { backofficeSharedDataService } from '@/components/Backoffice/Store/backoffice-shared-data-service'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { onlyFloat, onlyAlphaNumeric, onlyNumber, timeout, opcaoHabilitadoShared, campoHabilitadoShared } from '@/utils/common'
import { Agendamento, Autorizacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { TipoUsuarioEnum, Procedimento, Equipamento, OpmeMaterial, GrupoOpmes } from '@/types/_'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'
import BackofficeHonorarioMedico from './components/formulario/BackofficeHonorarioMedico.vue'
import BackofficeHonorarioAnestesista from './components/formulario/BackofficeHonorarioAnestesista.vue'
import BackofficeEquipeMedica from './components/formulario/BackofficeEquipeMedica.vue'
import BackofficeReservaHemocomponentes from './components/formulario/BackofficeReservaHemocomponentes.vue'

@Component({
  components: {
    BackofficeHonorarioMedico,
    BackofficeHonorarioAnestesista,
    BackofficeEquipeMedica,
    BackofficeReservaHemocomponentes,
  },
})
export default class ModalAlterarSolicitacao extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum

  backofficeSharedDataService = backofficeSharedDataService

  agd: any = new Agendamento.Agendamento()
  aut: any = new Autorizacao.Autorizacao()

  $refs!: {
    solicitacaoAlteradaForm: any,
    opmeForm: any,
    reservaUTI: any,
    honorarioMedico: any,
    honorarioAnestesista: any,
    equipeMedica: any,
    hemocomponentes: any,
  }

  solicitacaoAlteradaForm: any = {
    valid: true,
    hospitalId: [(v: any) => !!v || 'Campo obrigatório.'],
    convenioId: [(v: any) => !!v || 'Campo obrigatório.'],
    planoId: [(v: any) => !!v || 'Campo obrigatório.'],
    categoriaId: [(v: any) => !!v || 'Campo obrigatório.'],
    carteirinha: [(v: any) => this.validateCarteirinha(v)],
    carater: [(v: any) => !!v || 'Campo obrigatório.'],
    instrumentadorExternoEspecificar: [],
    tipoProcedimento: [],
    diaria: [],
    diariaUti: [],
    reservaUTI: [],
    comorbidade: [],
    medicacaoDapt: [],
    funcaoRenal: [],
    complexidade: [],
    hospitalAnesthetist: [() => this.validateHospitalAnesthetist()],
  }

  validateHospitalAnesthetist() {
    if (!this.opcaoHabilitado('alterarSolicitacao', 'naoEditarAnestesista') && this.getBackofficeGlobalStore.solicitacaoAlterada.anestesiaDoHospital === 'Nao' && !this.hospitalAnesthetist.id) {
      return 'Selecione um anestesista.'
    }
    return true
  }

  validateCarteirinha(v: any) {
    if (!!this.formulario && !!this.formulario.carteirinha && !!this.formulario.carteirinha.obrigatorio) {
      return !!v || 'Campo obrigatório.'
    }
    return true
  }

  lateralidades: any[] = [
    { key: 'Esquerdo', display: 'Esquerdo' },
    { key: 'Direito', display: 'Direito' },
    { key: 'Bilateral', display: 'Bilateral' },
    { key: 'NaoAplica', display: 'Não se aplica' },
  ]

  errorMessage: any = {
    errorProcedimento: '',
  }

  loadCancelar: boolean = false
  loadFechar: boolean = false
  loadAlterar: boolean = false
  loadHospital: boolean = false
  loadConvenio: boolean = false
  loadPlano: boolean = false
  loadCategoria: boolean = false
  loadProcedimentoPrincipal: boolean = false
  loadProcedimentosAssociados: boolean = false
  loadOpme: boolean = false
  loadingEquipamento = false
  loadAtualizarLateralidade: string = ''
  loadRemoveProcedimentosAssociados: string = ''
  loadRemoveGrupoOpme: string = ''
  loadRemoveOpmeGrupoOpme: string = ''

  loadEditarFornecedores: string = ''

  lastSelectedEquipmentsBeforeHospitalChange: string[] = []

  opmeRules = {
    id: [(v: any) => !!v || 'Campo obrigatório'],
    quantidade: [(v: any) => !!v || 'Campo obrigatório'],
    fornecedor1: [(v: any) => !!v || 'Campo obrigatório'],
    fornecedor2: [],
    fornecedor3: [],
    medidaTamanho: [(v: any) => this.getOPMEMeasureFieldRules(v)],
  }

  hospitalDiaMessage: string = 'Todos os procedimentos indicados são autorizados apenas em regime de <strong>Hospital Dia</strong> para a operadora selecionada. Faremos as seguintes tratativas:'

  hospitalAnesthetist = {
    id: '',
    nome: '',
    crm: '',
    temVinculoHospital: null,
  }

  getOPMEMeasureFieldRules(value) {
    if (this.getBackofficeGlobalStore.currentTemplate.formulario.opmes.medidaTamanho && this.getBackofficeGlobalStore.currentTemplate.formulario.opmes.medidaTamanho.obrigatorio) {
      return !!value || 'Campo obrigatório.'
    }
    return true
  }

  get loadingEditarFornecedores() {
    return this.loadEditarFornecedores
  }

  set loadingEditarFornecedores(value: string) {
    this.loadEditarFornecedores = value
  }

  get formulario() {
    return this.getBackofficeGlobalStore.currentTemplate.formulario
  }

  get fornecedorLabel() {
    return this.formulario && this.formulario.opmes && this.formulario.opmes.fornecedorLabel
      ? this.formulario.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get loadingHospital() {
    return this.loadHospital
  }

  set loadingHospital(value: boolean) {
    this.loadHospital = value
  }

  get loadingConvenio() {
    return this.loadConvenio
  }

  set loadingConvenio(value: boolean) {
    this.loadConvenio = value
  }

  get loadingPlano() {
    return this.loadPlano
  }

  set loadingPlano(value: boolean) {
    this.loadPlano = value
  }

  get loadingCategoria() {
    return this.loadCategoria
  }

  set loadingCategoria(value: boolean) {
    this.loadCategoria = value
  }

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(value: boolean) {
    this.loadCancelar = value
  }

  get loadingFechar() {
    return this.loadFechar
  }

  set loadingFechar(value: boolean) {
    this.loadFechar = value
  }

  get loadingAlterar() {
    return this.loadAlterar
  }

  set loadingAlterar(value: boolean) {
    this.loadAlterar = value
  }

  get loadingRemoveProcedimentosAssociados() {
    return this.loadRemoveProcedimentosAssociados
  }

  set loadingRemoveProcedimentosAssociados(value: string) {
    this.loadRemoveProcedimentosAssociados = value
  }

  get loadingRemoveGrupoOpme() {
    return this.loadRemoveGrupoOpme
  }

  set loadingRemoveGrupoOpme(value: string) {
    this.loadRemoveGrupoOpme = value
  }

  get loadingRemoveOpmeGrupoOpme() {
    return this.loadRemoveOpmeGrupoOpme
  }

  set loadingRemoveOpmeGrupoOpme(value: string) {
    this.loadRemoveOpmeGrupoOpme = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get showModalAnestesistas() {
    return this.getBackofficeGlobalStore.modal.listaDeAnestesistas
  }

  get showModalAlterarSolicitacao() {
    return this.getBackofficeGlobalStore.modal.alterarSolicitacao
  }

  set showModalAlterarSolicitacao(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value })
  }

  get hospitais() {
    return this.getBackofficeGlobalStore.hospitais
  }

  get convenios() {
    return this.getBackofficeGlobalStore.convenios
  }

  get planos() {
    return this.getBackofficeGlobalStore.planos
  }

  get categorias() {
    return this.getBackofficeGlobalStore.categorias
  }

  get loadingAtualizarLateralidade() {
    return this.loadAtualizarLateralidade
  }

  set loadingAtualizarLateralidade(value: string) {
    this.loadAtualizarLateralidade = value
  }

  get loadingProcedimentoPrincipal() {
    return this.loadProcedimentoPrincipal
  }

  set loadingProcedimentoPrincipal(value: boolean) {
    this.loadProcedimentoPrincipal = value
  }

  get loadingProcedimentosAssociados() {
    return this.loadProcedimentosAssociados
  }

  set loadingProcedimentosAssociados(value: boolean) {
    this.loadProcedimentosAssociados = value
  }

  get loadingOpme() {
    return this.loadOpme
  }

  set loadingOpme(value: boolean) {
    this.loadOpme = value
  }

  get getErrorMessage() {
    return this.errorMessage
  }

  set getErrorMessage(value: any) {
    this.errorMessage = value
  }

  get getProcedimentoAssociados() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.procedimentosAssociados
  }

  get grupoOpmeDaSolicitacao() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpmeDaSolicitacao
  }

  get categoriaCoberturaVigente() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.categoriaCoberturaVigente !== undefined) {
      return this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.categoriaCoberturaVigente
    }
    return true
  }

  campoObrigatorioLabel(label: string, campo: string) {
    if (this.campoObrigatorio(campo)) return `${label} *`
    return label
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getBackofficeGlobalStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario[campo]
      && (formulario.formulario[campo].obrigatorio
        || formulario.formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario.formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  pasteAlphaNumeric(event: ClipboardEvent) {
    event.preventDefault()
    const alphaNumericPattern = /[^ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-]+/ig
    // @ts-ignore
    const stringPattern = (event.clipboardData || window.clipboardData).getData('text')
    this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.carteirinha = stringPattern.replace(alphaNumericPattern, '').substring(0, this.formulario.carteirinha.tamanhoMaximoDeCaracteres || 30)
  }

  get showPrivateOPMEField() {
    return this.formulario.opmes
      && this.formulario.opmes.campos
      && this.formulario.opmes.campos.opcaoParticular
  }

  async checkCategoriaCoberturaVigente(categoriaId: string) {
    const { hospital } = this.getBackofficeGlobalStore.solicitacaoAlterada
    // @ts-ignore
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Categoria') return
    this.loadingCategoria = true
    const request = await this.getBackofficeGlobalStore.consultaCoberturaVigente(categoriaId)
    if (request.success) this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(request.data.temCoberturaVigente)
    this.loadingCategoria = false
  }

  setAnesthetist() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista) {
      this.hospitalAnesthetist = {
        nome: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.nome,
        crm: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.crm,
        temVinculoHospital: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.temVinculoHospital,
        id: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.id,
      }
    }
  }

  @Watch('showModalAnestesistas')
  onAnesthetistChange(anesthetist) {
    if (!anesthetist) {
      this.setAnesthetist()
      this.$refs.solicitacaoAlteradaForm.validate()
    }
  }

  hospitalAnesthetistChange(value) {
    if (value === 'Sim' || value === 'NaoAplica') {
      this.hospitalAnesthetist = {
        id: '',
        nome: '',
        crm: '',
        temVinculoHospital: null,
      }
    }
  }

  changeAnesthetist() {
    this.getBackofficeGlobalStore.setModal({ name: 'listaDeAnestesistas', value: true })
  }

  modalOpmeChange() {
    this.$forceUpdate()
  }

  onlyNumberUtil(e: KeyboardEvent) {
    return onlyNumber(e)
  }

  onlyAlphaNumericUtil(e: KeyboardEvent) {
    return onlyAlphaNumeric(e)
  }

  onlyFloatUtil(value: number) {
    return onlyFloat(value)
  }

  materialChange(data: OpmeMaterial, index: number) {
    this.getBackofficeGlobalStore.materialChange({ opme: data, index })
  }

  adicionarOpme() {
    this.getBackofficeGlobalStore.adicionarOpme()
    this.$forceUpdate()
  }

  deleteOpme(index: number) {
    this.getBackofficeGlobalStore.deleteOpme(index)
    this.$forceUpdate()
  }

  gradeCompletaChange(data: GrupoOpmes) {
    // eslint-disable-next-line
    data.observacao = ''
    this.$forceUpdate()
  }

  showModalCadastrarMaterial() {
    this.getBackofficeGlobalStore.setShowModalCadastrarMaterial(true)
  }

  showModalCadastrarFornecedor() {
    this.getBackofficeGlobalStore.setShowModalCadastrarFornecedor(true)
  }

  async removeProcedimentosAssociado(procedimentoId: string) {
    this.loadingRemoveProcedimentosAssociados = procedimentoId
    await this.getBackofficeGlobalStore.removeProcedimentosAssociadoBackoffice(procedimentoId)
    this.loadingRemoveProcedimentosAssociados = ''
  }

  async deleteOpmeFromGrupoOpme(grupoOpmeId: string, opmeId: string) {
    this.loadingRemoveOpmeGrupoOpme = `${grupoOpmeId}${opmeId}`
    await this.getBackofficeGlobalStore.removerOpmeDoGrupo({ grupoOpmeId, opmeId })
    this.loadingRemoveOpmeGrupoOpme = ''
  }

  async inserirLateralidade(procedimentoId: string, event) {
    this.loadingAtualizarLateralidade = procedimentoId
    const request = await this.getBackofficeGlobalStore.updateProcedimentoBySolicitacaoId({ procedimentoId, lateralidade: event })
    if (!request.success) EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Houve um problema ao atualizar a lateralidade', icon: 'warning', color: '#C62828' })
    this.loadingAtualizarLateralidade = ''
  }

  async showModalProcedimentoPrincipal() {
    this.loadingProcedimentoPrincipal = true
    const request = await this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch('')

    if (request.success) {
      this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentoPrincipal', value: true })
      this.getErrorMessage.errorProcedimento = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingProcedimentoPrincipal = false
  }

  async showModalProcedimentosAssociados() {
    this.loadingProcedimentosAssociados = true
    const request = await this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch('')

    if (request.success) {
      this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentosAssociados', value: true })
      this.getErrorMessage.errorProcedimento = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingProcedimentosAssociados = false
  }

  async showModalOpme() {
    this.loadingOpme = true
    if (this.getBackofficeGlobalStore.procedimentoPrincipal && this.getBackofficeGlobalStore.procedimentoPrincipal.id !== '' && !!this.getBackofficeGlobalStore.procedimentosAssociados) {
      const { procedimentoPrincipal, procedimentosAssociados } = this.getBackofficeGlobalStore
      const codigoProcedimentos: any[] = []
      if (procedimentosAssociados.length > 0) {
        procedimentosAssociados.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
      }
      codigoProcedimentos.unshift(procedimentoPrincipal.codigo)
      await this.getBackofficeGlobalStore.getGrupoOpmeByMedico(codigoProcedimentos)
      this.getBackofficeGlobalStore.setModal({ name: 'editarOpme', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingOpme = false
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  get template() {
    return this.getBackofficeGlobalStore.template
  }

  get hospital() {
    return this.getBackofficeGlobalStore.hospitais.find((hosp: any) => hosp.id === this.getBackofficeGlobalStore.solicitacaoAlterada.hospitalId)!
  }

  async hospitalChange(hospitalId: string) {
    this.loadingConvenio = true
    this.getBackofficeGlobalStore.clearConvenios()
    this.getBackofficeGlobalStore.clearPlanos()
    this.getBackofficeGlobalStore.clearCategorias()
    this.$refs.solicitacaoAlteradaForm.resetValidation()

    this.lastSelectedEquipmentsBeforeHospitalChange = this.getBackofficeGlobalStore.solicitacaoAlterada.equipamentos
      .map((elem: Equipamento) => elem.nome)
    this.getBackofficeGlobalStore.clearSolicitacaoAlteradaEquipamentos()

    await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
    await this.getBackofficeGlobalStore.getAllConvenios(hospitalId)
    this.loadingConvenio = false
  }

  async convenioChange() {
    const { formulario } = this
    this.loadingPlano = true
    this.loadingCategoria = true
    this.getBackofficeGlobalStore.clearPlanos()
    this.$refs.solicitacaoAlteradaForm.resetValidation()
    const { hospital, hospitalId, paciente } = this.getBackofficeGlobalStore.solicitacaoAlterada
    const response = await this.getBackofficeGlobalStore.getAllPlanos({ hospitalId, convenioId: paciente.convenioId })
    if (response.success) {
      this.solicitacaoAlteradaForm.planoId = response.data.length > 0
        ? [(v: any) => !!v || 'Campo obrigatório.']
        : []
    }

    if (formulario && formulario.categoria && formulario.categoria.habilitado) {
      this.getBackofficeGlobalStore.clearCategoria()
      this.getBackofficeGlobalStore.clearCategorias()
      if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
        this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(undefined)
      }
    }

    this.loadingPlano = false
    this.loadingCategoria = false
  }

  async planoChange(planoId = '') {
    const { formulario } = this
    const { hospital, hospitalId, paciente } = this.getBackofficeGlobalStore.solicitacaoAlterada

    if (planoId && formulario && formulario.categoria && formulario.categoria.habilitado) {
      this.loadingCategoria = true
      this.getBackofficeGlobalStore.clearCategoria()
      this.getBackofficeGlobalStore.clearCategorias()
      this.$refs.solicitacaoAlteradaForm.resetValidation()
      const request = await this.getBackofficeGlobalStore.getAllCategoriasByPlano({ hospitalId, planoId, convenioId: paciente.convenioId })
      if (request.success) {
        this.solicitacaoAlteradaForm.categoriaId = request.data.length > 0
          ? [(v: any) => !!v || 'Campo obrigatório.']
          : []
      } else {
        this.getBackofficeGlobalStore.clearCategorias()
      }

      if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
        this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(undefined)
      }

      this.loadingCategoria = false
    }
  }

  setCarater(key: string) {
    switch (key) {
      case 'EletivoAutorizacao':
        return 'Eletivo'
      case 'Urgencia':
        return 'Urgência'
      default:
        return 'Emergência'
    }
  }

  setLateralidade(key: any) {
    switch (key) {
      case 'NaoAplica':
        return 'Não Aplica'
      case 'Direito':
        return 'Direito'
      case 'Esquerdo':
        return 'Esquerdo'
      case 'Bilateral':
        return 'Bilateral'
      default:
        return 'Não Aplica'
    }
  }

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    id1 = id1 || 'id1'
    id2 = id2 || 'id2'
    id3 = id3 || 'id3'

    if (
      id1 === id2
      || id1 === id3
      || id2 === id3
    ) {
      return true
    }

    return false
  }

  possuiFornecedoresDuplicados() {
    const exists = !this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.every((opme) => {
      const { fornecedor1Id, fornecedor2Id, fornecedor3Id } = opme
      return !this.possuiOMesmoFornecedor(fornecedor1Id, fornecedor2Id, fornecedor3Id)
    })

    if (exists) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Existem materiais com fornecedores duplicados, revise a lista de materiais.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }

    return exists
  }

  isGreaterThanZero(v: any) {
    const num: any = parseInt(v, 10)
    return Number.isNaN(num) || num < 1 ? 'Campo obrigatório.' : false
  }

  reservaUTIWarning: string = ''
  reservaUTIDisabled: boolean = false

  validarDiariaHospital(e: string | null) {
    const { diaria } = this.formulario
    if (diaria && diaria.obrigatorio) {
      this.solicitacaoAlteradaForm.diaria = e === 'Ambulatorial'
        ? []
        : [(v: any) => this.isGreaterThanZero(v)]
      if (e === 'Ambulatorial') this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    }

    if (this.opcaoHabilitado('formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')) {
      if (e === 'Ambulatorial' && this.opcaoHabilitado('reservaUti', 'semReservaUti')) {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 'SemReserva' })
        this.reservaUTIWarning = 'Quando o tipo de procedimento é ambulatorial, a reserva de UTI fica suspensa.'
        this.reservaUTIDisabled = true
        if (this.campoHabilitado('diariUti')) this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diariaUti', value: 0 })
      } else {
        this.reservaUTIWarning = ''
        this.reservaUTIDisabled = false
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 0 })
        this.$refs.reservaUTI.resetValidation()
      }
    }
  }

  validarDiariaUti(e: any) {
    const { diariaUti } = this.formulario
    if (diariaUti && diariaUti.obrigatorio) {
      this.solicitacaoAlteradaForm.diariaUti = ['SemReserva', 'ReservaUtiNao'].includes(e)
        ? []
        : [(v: any) => this.isGreaterThanZero(v)]
    }
    if (['SemReserva', 'ReservaUtiNao'].includes(e)) this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diariaUti', value: null })
  }

  get tipoAcomodacaoHis() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada
      && this.getBackofficeGlobalStore.solicitacaoAlterada.hospital
      && !!this.getBackofficeGlobalStore.solicitacaoAlterada.hospital.utilizaTipoAcomodacaoHospital
  }

  async alterarSolicitacao() {
    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    this.loadingAlterar = true

    if (this.$refs.honorarioAnestesista && !this.$refs.honorarioAnestesista.$refs.honorarioAnestesista.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.honorarioMedico && !this.$refs.honorarioMedico.$refs.honorarioMedico.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.hemocomponentes && !this.$refs.hemocomponentes.$refs.reservaHemocomponentes.validate()) {
      this.loadingAlterar = false
      return
    }

    this.$refs.solicitacaoAlteradaForm.validate()
    const solicitacaoAlteradaFormErrors = await this.$refs.solicitacaoAlteradaForm.errorBag

    this.$refs.opmeForm.validate()
    const errorsOpmeForm = await this.$refs.opmeForm.errorBag

    let counterValid = Object.values(solicitacaoAlteradaFormErrors).filter(e => e === true).length
    counterValid += Object.values(errorsOpmeForm).filter(e => e === true).length

    if (counterValid < 1) {
      if (this.hospital.usaProcedimentosApenasHospitalDia && this.opcaoHabilitado('tipoProcedimento', 'hospitalDia')) {
        await this.getBackofficeGlobalStore.getProcedimentosHospitalDiaByHospital()

        if (this.getBackofficeGlobalStore.todosProcedimentosHospitalDia) {
          const hospitalDiaExpected: boolean = this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'HospitalDia'
          const diariaExpected: boolean = this.campoHabilitado('diaria') && this.getBackofficeGlobalStore.solicitacaoAlterada.diaria === 1
          const reservaUtiExpected: boolean = (this.opcaoHabilitado('reservaUti', 'reservaUtiNao') || this.opcaoHabilitado('reservaUti', 'semReservaUti')) && ['SemReserva', 'ReservaUtiNao'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.reservaUTI)

          if (!hospitalDiaExpected || !diariaExpected || !reservaUtiExpected) {
            this.getSolicitacaoCirurgiaStore.setModal({ name: 'procedimentosApenasHospitalDiaWarning', value: true })
            this.loadingAlterar = false
            return
          }
        }
      }

      if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesiaDoHospital === 'Nao') {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
          field: 'anestesistaId',
          value: this.hospitalAnesthetist.id,
        })
      }

      const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAtualizaSolicitacao()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação alterada com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
        await this.store.loadAgendamentosMedicoSearch()
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao alterar a solicitação.', icon: 'warning', color: '#C62828', timeout: 7500 })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counterValid} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }

    this.loadingAlterar = false
  }

  async fechar(botao: string) {
    const btn: string = botao.toUpperCase() === 'CANCELAR' ? 'loadingCancelar' : 'loadingFechar'
    this[btn] = true
    await timeout(500)
    await this.closeModal()
    this.showModalAlterarSolicitacao = false
    this.loadingAlterar = false
    this[btn] = false
  }

  async closeModal() {
    await this[this.implemantation].desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoId)
    this.$refs.solicitacaoAlteradaForm.reset()
    this.getBackofficeGlobalStore.clearSolicitacaoAlterada()
    this.getBackofficeGlobalStore.clearGrupoOpmeDaSolicitacao()
    this.getBackofficeGlobalStore.clearTipoAcomodacaoItems()
    this.$refs.solicitacaoAlteradaForm.resetValidation()
    if (this.$refs.honorarioMedico) this.$refs.honorarioMedico.$refs.honorarioMedico.resetValidation()
    if (this.$refs.honorarioAnestesista) this.$refs.honorarioAnestesista.$refs.honorarioAnestesista.resetValidation()
    if (this.$refs.hemocomponentes) {
      this.$refs.hemocomponentes.$refs.reservaHemocomponentes.resetValidation()
      this.$refs.hemocomponentes.$refs.reservaHemocomponentes.reset()
    }
    this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value: false })
    this.lastSelectedEquipmentsBeforeHospitalChange = []
    this.getBackofficeGlobalStore.clearTemplate()
    this.backofficeSharedDataService.reset()
  }

  get implemantation() {
    switch (this.$route.name) {
      case 'BackofficeAgendamento':
        return 'agd'
      case 'BackofficeAutorizacao':
        return 'aut'
      default:
        return 'agd'
    }
  }

  get store() {
    return this.implemantation === 'agd' ? this.getBackofficeAgendamentoStore : this.getBackofficeAutorizacaoStore
  }

  get doctorsSurgeryTeam() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica
  }

  set doctorsSurgeryTeam(doctorData) {
    this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica = doctorData
  }

  addDoctorToSurgeryTeam() {
    this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' })
  }

  @Watch('showModalAlterarSolicitacao')
  onChangeShowModalAlterarSolicitacao(value: boolean) {
    if (value) {
      this.$refs.solicitacaoAlteradaForm.resetValidation()
      this.setAnesthetist()
      if (this.campoHabilitado('instrumentadorExterno')) {
        this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.push(v => this.validateInstrumentadorExterno(v))
      }

      if (this.opcaoHabilitado('formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')) {
        if (this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'Ambulatorial' && this.opcaoHabilitado('reservaUti', 'semReservaUti')) {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 'SemReserva' })
          this.reservaUTIWarning = 'Quando o tipo de procedimento é ambulatorial, a reserva de UTI fica suspensa.'
          this.reservaUTIDisabled = true
        }
      }

      if (
        ['Internacao', 'HospitalDia'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento)
        && this.campoHabilitado('diaria') && this.template.formulario.diaria.obrigatorio
      ) {
        this.solicitacaoAlteradaForm.diaria.push((v: any) => this.isGreaterThanZero(v))
      }

      if (
        !['ReservaUtiNao', 'SemReserva'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.reservaUTI)
        && this.campoHabilitado('diariaUti') && this.template.formulario.diariaUti.obrigatorio
      ) {
        this.solicitacaoAlteradaForm.diariaUti.push((v: any) => this.isGreaterThanZero(v))
      }

      if (this.campoHabilitado('equipeMedica')
        && this.opcaoHabilitado('equipeMedica', 'dadosDoConselho')
        && this.getBackofficeGlobalStore.solicitacaoAlterada.temEquipeMedica) {
        if (!this.doctorsSurgeryTeam || this.doctorsSurgeryTeam.length === 0) {
          this.addDoctorToSurgeryTeam()
        }
      }
    }
  }

  get temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  get temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }

  async openModalEditarFornecedorOPME(flag: string) {
    this.loadingEditarFornecedores = flag
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi('solicitacaoAlterada')
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditarFornecedores = ''
  }

  async showModalEquipamento() {
    this.loadingEquipamento = true
    await this.getBackofficeGlobalStore.getAlterarSolicitacaoEquipamentoGruposApiSearch('')
    this.getBackofficeGlobalStore.setModal({ name: 'editarEquipamento', value: true })
    this.loadingEquipamento = false
  }

  /** Instrumentador externo */
  validateInstrumentadorExterno(value: any) {
    if (['', null, undefined].includes(value) || (parseInt(value, 10) < 1)) return 'Campo obrigatório.'
    return false
  }

  instrumentadorExternoChange(instrumentadorExterno: boolean) {
    if (instrumentadorExterno) {
      this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.push(v => this.validateInstrumentadorExterno(v))
    } else {
      this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.splice(0, this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.length)
      this.getBackofficeGlobalStore.clearSolicitacaoAlteradaInstrumentadorExternoEspecificar()
    }
  }

  // Permissions

  get canShowLastSelectedEquipmentsBeforeHospitalChange() {
    return this.lastSelectedEquipmentsBeforeHospitalChange.length > 0
  }

  canEditProcedimentoPrincipal() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canAddOrDeleteProcedimentoAssociado() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canAddOrDeleteOpme() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canEditNumeroLeito() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.acoes.permiteEditarLeitoDoPaciente
  }

  canEditNumeroAtendimento() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.acoes.permiteEditarNumeroDoAtendimentoAoPacienteNoHospital
  }

  mounted() {
    EventBus.$on('refreshSolicitacaoAlterada', (value: boolean) => this.$forceUpdate())
    EventBus.$on('alterarSolicitacao', this.alterarSolicitacao)
    this.$forceUpdate()
  }
}
